document.addEventListener('DOMContentLoaded', function () {
    const header = document.getElementById('global-header');
    const SCROLL_THRESHOLD = 10;
    const INVERT_THRESHOLD = window.innerHeight;
    let lastScrollY = window.scrollY;
    let isScrollingDown = false;

    function throttle(func, limit) {
        let inThrottle;
        return function(...args) {
            if (!inThrottle) {
                func.apply(this, args);
                inThrottle = true;
                setTimeout(() => inThrottle = false, limit);
            }
        }
    }

    function updateHeaderVisibility(currentScrollY) {
        // Always show header at the top of the page
        if (currentScrollY === 0) {
            header.classList.remove('hidden');
            isScrollingDown = false;
            return;
        }

        if (Math.abs(currentScrollY - lastScrollY) >= SCROLL_THRESHOLD) {
            if (currentScrollY > lastScrollY) {
                // Scrolling down
                if (!isScrollingDown) {
                    header.classList.add('hidden');
                    isScrollingDown = true;
                }
            } else {
                // Scrolling up
                if (isScrollingDown) {
                    header.classList.remove('hidden');
                    isScrollingDown = false;
                }
            }
            lastScrollY = currentScrollY;
        }
    }

    function updateHeroClass(currentScrollY) {
        if (currentScrollY >= INVERT_THRESHOLD) {
            header.classList.remove('hero');
        } else {
            header.classList.add('hero');
        }
    }

    const handleScroll = throttle(function() {
        const currentScrollY = window.scrollY;
        updateHeaderVisibility(currentScrollY);
        updateHeroClass(currentScrollY);
    }, 100); // Throttle to run at most every 100ms

    window.addEventListener('scroll', handleScroll);

    handleScroll();
});


document.addEventListener("DOMContentLoaded", function() {
    document.body.classList.add("fade-in");

    window.addEventListener("load", function() {
        document.body.classList.add("fade-in-loaded");
    });


    document.querySelectorAll("a").forEach(function(link) {
        link.addEventListener("click", function(event) {
            
            if (link.hostname === window.location.hostname) {
                event.preventDefault(); 
                document.body.classList.remove("fade-in-loaded"); 
                setTimeout(function() {
                    window.location.href = link.href; 
                }, 150); 
            }
        });
    });
});
